import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { ValuePropKey } from '@/utils/enum'
import { InfoModalDetail } from '@/models/InfoModalDetail'
import {
  bookingProtectionModalDetail,
  liveSupportModalDetail,
  qualifiedOperatorsModalDetail,
  vehicleLocationTrackingModalDetail
} from '@/utils/infoModals'


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotFooterValueProp',
  props: {
  valuePropKey: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



const valueProp = computed((): InfoModalDetail | null => {
  switch(props.valuePropKey) {
    case ValuePropKey.BookingProtection:
      return bookingProtectionModalDetail
    case ValuePropKey.Tracking:
      return vehicleLocationTrackingModalDetail
    case ValuePropKey.LiveSupport:
      return liveSupportModalDetail
    case ValuePropKey.QualifiedOperators:
      return qualifiedOperatorsModalDetail
    default:
      return null
  }
})

const icon = computed(() => {
  return valueProp?.value.icon
})

const label = computed(() => {
  return valueProp?.value.label
})

const modalText = computed(() => {
  return valueProp?.value.modalText
})

return { __sfc: true,props, valueProp, icon, label, modalText }
}

})